import { render, staticRenderFns } from "./TabBarLoadingComponent.vue?vue&type=template&id=992e9904&scoped=true&"
import script from "./TabBarLoadingComponent.vue?vue&type=script&lang=js&"
export * from "./TabBarLoadingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992e9904",
  null
  
)

export default component.exports